/**
 * Componente: Reporte de fallo de impresión ("¿qué pasó?"). Se abre
 * cuando el operador contesta "No" en ConfirmarImpresionModal. El motivo
 * "otro" pide un detalle obligatorio — es justo el que dispara el pedido
 * de autorización al admin (los demás motivos son técnicos conocidos y
 * dejan reintentar solo, ver backend /licencias/:id/reportar-fallo).
 */

import React, { useState } from 'react';
import { IconCerrar, IconAdvertencia } from './icons';

const MOTIVOS_FALLO = [
  { value: 'sin_tarjetas', label: 'Sin tarjetas' },
  { value: 'sin_ribbon', label: 'Sin ribbon' },
  { value: 'fallo_conexion', label: 'Fallo de conexión con la impresora' },
  { value: 'cancelacion_erronea', label: 'Cancelación errónea' },
  { value: 'otro', label: 'Otro' },
];

const ReportarFalloImpresionModal = ({ procesando, onConfirmar, onCancelar }) => {
  const [motivoCategoria, setMotivoCategoria] = useState('sin_tarjetas');
  const [motivoDetalle, setMotivoDetalle] = useState('');
  const [error, setError] = useState('');

  const cambiarMotivo = (valor) => {
    setMotivoCategoria(valor);
    setError('');
  };

  const confirmar = () => {
    if (motivoCategoria === 'otro' && !motivoDetalle.trim()) {
      setError('Contá brevemente qué pasó');
      return;
    }
    onConfirmar(motivoCategoria, motivoDetalle.trim());
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content confirmar-eliminar-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>¿Qué pasó con la impresión?</h2>
          <button className="modal-close" onClick={onCancelar} disabled={procesando}><IconCerrar size={18} /></button>
        </div>

        <div className="modal-body">
          {error && (
            <div className="alert alert-error">
              <IconAdvertencia size={18} />
              <p>{error}</p>
            </div>
          )}

          <div className="form-field">
            <label>Motivo</label>
            <select
              className="padron-input"
              value={motivoCategoria}
              onChange={(e) => cambiarMotivo(e.target.value)}
              disabled={procesando}
            >
              {MOTIVOS_FALLO.map((m) => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </select>
          </div>

          {motivoCategoria === 'otro' && (
            <div className="form-field">
              <label>Contanos qué pasó *</label>
              <textarea
                className="padron-input"
                value={motivoDetalle}
                onChange={(e) => setMotivoDetalle(e.target.value)}
                rows={3}
                disabled={procesando}
              />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-cancelar" onClick={onCancelar} disabled={procesando}>
            Cancelar
          </button>
          <button type="button" className="btn-guardar" onClick={confirmar} disabled={procesando}>
            {procesando ? 'Enviando...' : 'Confirmar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportarFalloImpresionModal;
